import TableList from 'components/commons/TableList/TableList.component';
import { useBillingSubTab } from 'hooks/billingSubTab.hook';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import BillingTableBody from './BillingTableBody.component';
import BillingTableHeader from './BillingTableHeader.component';
import MembersBillingTableBody from './Member/MembersBillingTableBody.component';
import MembersBillingTableHeader from './Member/MembersBillingTableHeader.component';
import MembersBillingAggregationTableBody from './memberAggregation/MembersBillingAggregationTableBody.component';
import MembersBillingAggregationTableHeader from './memberAggregation/MembersBillingAggregationTableHeader.component';

const BillingTable = () => {
	const { claimsBilling, membersBilling, memberAggregationBilling } =
		useSelector((store: RootState) => store.billing);
	const progressIndicator = useSelector(
		(state: RootState) => state.progressIndicator,
	);

	const { isMembers, isMembersAggregation } = useBillingSubTab();
	const data = isMembers
		? membersBilling
		: isMembersAggregation
			? memberAggregationBilling
			: claimsBilling;

	let header = <></>;
	let body = <></>;

	if (isMembers) {
		header = <MembersBillingTableHeader />;
		body = <MembersBillingTableBody membersBilling={membersBilling} />;
	} else if (isMembersAggregation) {
		header = <MembersBillingAggregationTableHeader />;
		body = (
			<MembersBillingAggregationTableBody
				membersBilling={memberAggregationBilling}
			/>
		);
	} else {
		header = <BillingTableHeader />;
		body = <BillingTableBody claimsBilling={claimsBilling} />;
	}

	if (data.length === 0 && progressIndicator.isLoading) {
		body = <></>;
	}

	return <TableList header={header} body={body} />;
};

export default BillingTable;
